module.exports = __webpack_public_path__ + "img/portrait.3e7048b0.svg";